import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Provider } from "app/core/models/provider.model";
import { ProviderService } from 'app/core/services/provider.service';
import { UserTimingService } from 'app/core/services/user-timing.service';

import { ProviderHeaderComponent } from '../../components/provider-header/provider-header.component';
import { ProviderDetailComponent } from '../../components/provider-detail/provider-detail.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-provider',
    templateUrl: './capture-admin-provider.component.html',
    styleUrls: ['./capture-admin-provider.component.scss'],
    imports: [ProviderHeaderComponent, ProviderDetailComponent, MatProgressSpinner]
})
export class CaptureAdminProviderComponent implements OnInit, OnDestroy {
  private providerService = inject(ProviderService);
  private route = inject(ActivatedRoute);
  private userTimingService = inject(UserTimingService);

  provider: Provider;
  loading: boolean;
  enableDeactivateDate: boolean;
  showDeactivateDateIsRequiredMessage: boolean;
  deactivateDate: Date;

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.userTimingService.stop();
  }

  onProviderChange() {
    this.loadProvider();
  }

  private init() {
    this.startUserTimingService();
    this.loadProvider();
  }

  private startUserTimingService() {
    this.userTimingService.track({
      page: 'capture_admin_provider',
      recordId: this.npi,
    });
  }

  private get npi() {
    return this.route.snapshot.paramMap.get('npi');
  }

  private loadProvider() {
    this.loading = true;

    this.providerService.getByNpi(this.npi).subscribe(provider => {
      this.provider = provider;
      this.loading = false;
    });
  }
}
